export interface InternetUsage {
  dateFrom: Date | undefined
  dateTo: Date | undefined
  period: string
  usage: InternetUsageData[] | undefined
}
export interface InternetUsageData {
  date: string
  up: number
  down: number
}

export interface InternetStatusType {
  status: string
  ipAddress: string
  startTime: string
  stopTime: string
  callerId: string
  terminationCause: string
  uploadSpeed: number
  downloadSpeed: number
  usage: {
    up: number
    down: number
  }
}

export enum InternetType {
  XDSL = 'XDSL',
  FTTX = 'FTTX',
  BROADBAND = 'BROADBAND',
}

export enum InternetTypeDescription {
  XDSL = 'DSL',
  FTTX = 'GPON',
  BROADBAND = 'BROADBAND',
}

export interface InternetUsageRequest {
  type: InternetType
  connectionId: number
  dateFrom: Date | undefined
  dateTo: Date | undefined
  period: string
}

export const isInternetUsageRequest = (object: any): object is InternetUsageRequest => {
  if (object === undefined) {
    return false
  }
  return 'connectionId' in object && 'dateFrom' in object
}

export const isInternetUsage = (object: any): object is InternetUsage => {
  if (object === undefined) {
    return false
  }
  if ('usage' in object && Array.isArray(object.usage)) {
    return 'up' in object.usage[0]
  }
  return false
}

export const isInternetStatusType = (object: any): object is Array<InternetStatusType> => {
  if (object === undefined) {
    return false
  }
  return 'terminationCause' in object
}

export function getInternetTypeByString(value: string): InternetType {
  if (value.toLocaleUpperCase() === 'FTTX') {
    return InternetType.FTTX
  }
  return InternetType.XDSL
}
